import React , {Component} from 'react';
import Splitting from "splitting";
import anime from 'animejs/lib/anime.es.js';

class TwoColumnsSection extends Component {
    constructor(props) {
        super(props);
        this.state = {isVisible: false};
        this.titleToSplit = React.createRef();
        this.textAnime1 = React.createRef();
        this.textAnime2 = React.createRef();
        this.title = this.props.sectionData.sectionContent ? this.props.sectionData.sectionContent.title : this.props.sectionData.title;
    }

    componentDidMount () {
        const self = this;
        const splitTitle = Splitting({
            target: this.titleToSplit.current
        });
        const options = {
            autoplay: false,
            translateY: [
                { value: [10, 0], duration: 200 }
            ],
            opacity: [
                { value: [0, 1], duration: 1000 }
            ],
            easing: 'easeInOutQuad',
        };

        this.animation1 = anime({
            ...options,
            delay: anime.stagger(15, {start: 200}), // change back to 15
            targets: [this.title.length ? splitTitle[0].chars : ''],
            begin: function () {
                self.setState({isVisible: true});
            },
            complete: function() {
                self.animation2.play();
            }
        });

        this.animation2 = anime({
            ...options,
            delay: anime.stagger(200, {start: 200}),
            targets: [self.textAnime1.current, self.textAnime2.current],
            complete: function() {
                (self.props.parentCallback && self.props.parentCallback())
            }
        });
        if (this.props.isRevealed && !this.state.isVisible) {
            this.animation1.play();
        }
    }

    componentDidUpdate() {
        if (this.props.isRevealed && !this.state.isVisible) {
            this.animation1.play();
        }
    }

    render () {
        return (
            <div className={"two-columns-section row " + this.props.styleClass}>

                {this.title.length ?
                    <div className="col-12" ref={this.titleToSplit}>
                        <p className="section-title">
                            {this.title}
                        </p>
                    </div>
                    : ''
                }

                <div className="col-6" ref={this.textAnime1}>
                    <div className="section-description"
                         dangerouslySetInnerHTML={{__html: this.props.sectionData.sectionContent ? this.props.sectionData.sectionContent.col1 : this.props.sectionData.column1}}>
                    </div>
                </div>
                <div className="col-6" ref={this.textAnime2}>
                    <div className="section-description"
                         dangerouslySetInnerHTML={{__html: this.props.sectionData.sectionContent ? this.props.sectionData.sectionContent.col2 : this.props.sectionData.column2}}>
                    </div>
                </div>
            </div>

        )
    }
};

export default TwoColumnsSection;